export default __webpack_public_path__ + "static/media/unique.bbc2b282.jpg";